import React, { useEffect, useState, useRef, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import SearchTextBox from 'srcReact/components/common2/SearchTextBox'
import styles from './styles.module.scss'
import { messengerActions } from 'srcReact/MessengerPage'
import Icon from 'srcReact/components/icons/Icon'
import Avatar from 'srcReact/components/common2/Avatar'
import Button from 'srcReact/components/common2/Button'
import Spinner from 'srcReact/components/common2/Spinner'
import parentStyles from '../../styles.module.scss'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import ReactMenu from 'srcReact/components/common2/ReactMenu'

const ManageMembers = ({ closeModal }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    login: { user: loggedInUser },
    messenger: {
      openedConversation,
      searchedMembers,
      manageMemberLoading,
      loading,
      searchedMemberError,
      searchedMemberStats,
      organizationId
    }
  } = useSelector((state) => state)
  const [type, setType] = useState('search')
  const [membersToInvite, setMembersToInvite] = useState([])
  const [markMembersForUpdate, setMarkMembersForUpdate] = useState(false)
  const [userBeingProcessed, setUserBeingProcessed] = useState(-1)
  const [userIdForMessage, setUserIdForMessage] = useState(0)
  const [inviteMemberTriggered, setInviteMemberTriggered] = useState(false)
  const [search, setSearch] = useState('')
  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })
  const [selectedModalUser, setSelectedModalUser] = useState(null)
  const [currentMembers, setCurrentMembers] = useState([]) // useState(openedConversation ? openedConversation.active_users : [])
  const [is2memberChat, setIs2memberChat] = useState(false)

  useEffect(() => {
    if (type === 'search') {
      if (search.length === 0) {
        updateCurrentMembers()
      } else {
        const updatedConvMembers =
          openedConversation &&
          openedConversation.active_users.length > 0 &&
          openedConversation.active_users.filter((u) => `${u.firstname} ${u.lastname}`.toLowerCase().includes(search))
        setCurrentMembers([...updatedConvMembers])
      }
    } else {
      dispatch(messengerActions.searchMembers(search, organizationId, pagination))
    }
  }, [pagination, search])
  // useEffect(() => {
  //   if (isRefreshMessagePaused && changeConversation) {
  //     dispatch(messengerActions.createConversation(organizationId, userIdForMessage.toString()))
  //     setUserIdForMessage(0)
  //     close()
  //   }
  // }, [isRefreshMessagePaused, changeConversation])
  useEffect(() => {
    //reset membersToInvite once invited
    if (!manageMemberLoading && markMembersForUpdate) {
      setMembersToInvite([])
      setMarkMembersForUpdate(false)
      setUserBeingProcessed(-1)
      //close the modal once user is invited
      if (inviteMemberTriggered) {
        closeModal()
        setInviteMemberTriggered(false)
      }
    }
  }, [manageMemberLoading])
  useEffect(() => {
    if (search.length === 0) {
      updateCurrentMembers()
      setIs2memberChat(openedConversation.active_users.length <= 2 ? true : false)
    }
  }, [openedConversation.active_users])
  // useEffect(() => {
  //   moveLoggedInUserToFirstPosition()
  // }, [currentMembers])

  const getDropdownOptions = (user) => {
    const userId = user.id
    const items = []
    if (!is2memberChat && loggedInUser?.id !== userId) {
      items.push({
        text: t('messenger.sendMessage'),
        onClick: () => sendMessage(userId)
      })
    }
    if (
      user.is_conversation_admin === 0 &&
      openedConversation &&
      openedConversation.conversation.user_is_conversation_admin &&
      loggedInUser?.id !== userId
    ) {
      items.push({
        text: t('messenger.makeAdmin'),
        onClick: () => makeAdmin(userId)
      })
    }
    if (openedConversation && openedConversation.conversation.user_is_conversation_admin) {
      items.push({
        text: t('messenger.remove'),
        onClick: () => removeMember(userId)
      })
    }
    return items
  }
  const removeMember = (userId) => {
    setUserBeingProcessed(userId)
    setMarkMembersForUpdate(true)
    dispatch(messengerActions.removeMembersFromConversation(openedConversation.conversation.id, userId.toString()))
  }
  const makeAdmin = (userId) => {
    setUserBeingProcessed(userId)
    dispatch(messengerActions.setAdmin(openedConversation.conversation.id, userId, 1))
  }
  const sendMessage = (userId) => {
    // setUserIdForMessage(userId)
    // dispatch(messengerActions.setChangeConversation())
    // dispatch(messengerActions.pauseRefreshMessage())
    dispatch(messengerActions.createConversation(organizationId, userId.toString()))
    // setUserIdForMessage(0)
    close()
  }
  const lastMemberRef = useInfinitScroll(
    loading,
    searchedMemberStats && searchedMemberStats.remaining,
    searchedMemberStats && searchedMemberStats.nextOffset,
    setPagination,
    [loading]
  )
  const resetState = () => {
    setSearch('')
    setPagination({
      nextOffset: 0,
      isPagination: false
    })
    setMembersToInvite([])
    setType('search')
  }
  const close = () => {
    resetState()
    closeModal()
  }
  const inviteNew = () => {
    setType('invite-new')
    dispatch(messengerActions.searchMembers(search, organizationId, pagination))
  }
  const cancelInviting = () => {
    setType('search')
  }
  const handleSearch = (searchValue) => {
    if (searchValue.length >= 2 || searchValue.length === 0) {
      setPagination({
        nextOffset: 0,
        isPagination: false
      })
      setSearch(searchValue.toLowerCase())
    }
  }
  const showUserModal = (user, index) => {
    const lp = new LightProfileProto()
    lp.userId = user.id
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }

  const updateCurrentMembers = () => {
    if (openedConversation.active_users.length > 0) {
      if (!openedConversation.active_users[0].is_logged_user) {
        const user = openedConversation.active_users.find((u) => u.is_logged_user)
        const membersWithoutLoggedinuser = openedConversation.active_users.filter((u) => !u.is_logged_user)
        setCurrentMembers([{ ...user }, ...membersWithoutLoggedinuser])
      } else {
        setCurrentMembers([...openedConversation.active_users])
      }
    }
  }
  const addMemberToInvite = (member) => {
    setMembersToInvite([...membersToInvite, member])
  }
  const removeMemberFromInvite = (member) => {
    const filteredMembers = membersToInvite.filter((m) => m.user_id !== member.user_id)
    setMembersToInvite(filteredMembers)
  }
  const handleKeyPressed = (e) => {
    if (e.key === 'Escape') {
      e.stopPropagation()
    }
  }
  const inviteNewMembers = () => {
    if (membersToInvite.length > 0 && openedConversation) {
      const userIds = membersToInvite.map((m) => m.user_id).join(',')
      setMarkMembersForUpdate(true)
      setInviteMemberTriggered(true)
      dispatch(messengerActions.addMembersToConversation(openedConversation.conversation.id, userIds))
    }
  }

  return (
    <React.Fragment>
      <div className={styles.wrapper}>
        <h1 className={styles.title}>
          {type === 'search' ? t('messenger.header.manageMembers') : t('messenger.invite')}
        </h1>
        <div className={styles.searchOrAdd}>
          <SearchTextBox
            minimumSearchChar={2}
            size='large'
            iconPosition='start'
            placeholder={t('formlabel.searchMemberPlaceholder1')}
            handleSearch={handleSearch}
            cssClass={styles.searchContainer}
          />
        </div>
        {type === 'search' && !is2memberChat && (
          <button type='button' className={styles.inviteNew} onClick={inviteNew}>
            <Icon name='add' size='large' /> {t('messenger.inviteNew')}
          </button>
        )}
        {type === 'invite-new' ? (
          <React.Fragment>
            <div className={styles.list}>
              {searchedMembers &&
                searchedMembers.length > 0 &&
                searchedMembers.map((member, index) => {
                  const isLastMember = searchedMembers.length === index + 1
                  const isMemberAdded = isMemberAddedForInvitation(membersToInvite, member)
                  const isMemberInConversation = isMemberAlreadyInConversation(openedConversation, member)
                  return (
                    <button
                      type='button'
                      {...(isMemberInConversation
                        ? { onClick: null }
                        : isMemberAdded
                        ? {
                            onClick: () => removeMemberFromInvite(member)
                          }
                        : {
                            onClick: () => addMemberToInvite(member)
                          })}
                      className={`${styles.memberInList} ${isMemberInConversation && styles.memberInConv}`}
                      key={`${member.user_id}_${index}`}
                      ref={isLastMember ? lastMemberRef : null}>
                      {isMemberAdded && <div className={styles.indicatorAdded} />}
                      <Avatar
                        key={'member_' + member.id}
                        userId={member.id}
                        profilePicture={member.profile_picture_url}
                        firstname={member.firstname}
                        lastname={member.lastname}
                        imgWrapperSize='small'
                        onClickAction={() => showUserModal(member, index)}
                        mimeType={member.mime_type}
                        originalTag={member.original_tag}
                        isOriginal={member.is_original}
                        userStatus={member.status}
                        withExpertiseGroup={member.with_expertise_group}
                      />
                      <div className={styles.userProfile}>
                        <div className={styles.memberName}>
                          {member.status === 'deleted'
                            ? t('global.deletedUser')
                            : `${member.firstname} ${member.lastname}`}
                        </div>
                      </div>

                      {isMemberInConversation ? (
                        <span className={styles.addRemoveIconButton}>
                          <Icon name='check24' size='large' />
                        </span>
                      ) : isMemberAddedForInvitation(membersToInvite, member) ? (
                        <span className={styles.addRemoveIconButton}>
                          <Icon name='minus' size='large' />
                        </span>
                      ) : (
                        <span className={styles.addRemoveIconButton}>
                          <Icon name='add' size='large' />
                        </span>
                      )}
                    </button>
                  )
                })}
              {loading || (searchedMemberError && searchedMemberError === 'cancelTokenError') ? <Spinner /> : null}
            </div>

            <div className={styles.actionButtonWrapper}>
              <Button style='secondary' size='large' text={t('messenger.cancel')} handleClick={cancelInviting} />
              <Button
                style='primary'
                size='large'
                text={manageMemberLoading ? <Spinner isWhite={true} /> : t('messenger.invite')}
                handleClick={inviteNewMembers}
              />
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className={`${styles.list} ${styles.memberLists}`}>
              {currentMembers.length > 0 &&
                currentMembers.map((member, index) => {
                  let signature = member.is_logged_user ? t('messenger.you') : ''
                  const menuOptions = getDropdownOptions(member)
                  signature = member.is_conversation_admin
                    ? signature.length > 0
                      ? signature + ` - ${t('messenger.admin')}`
                      : t('messenger.admin')
                    : signature
                  return (
                    <div key={`${member.id}_${index}`} className={styles.memberInList}>
                      <Avatar
                        key={'member_' + member.id}
                        imgWrapperSize='small'
                        userId={member.id}
                        profilePicture={member.profile_picture_url}
                        firstname={member.firstname}
                        lastname={member.lastname}
                        onClickAction={() => showUserModal(member, index)}
                        mimeType={member.mime_type}
                        originalTag={member.original_tag}
                        isOriginal={member.is_original}
                        userStatus={member.status}
                        withExpertiseGroup={member.with_expertise_group}
                      />
                      <div className={styles.userProfile}>
                        <div className={styles.memberName}>
                          {member.status === 'deleted'
                            ? t('global.deletedUser')
                            : `${member.firstname} ${member.lastname}`}
                        </div>
                        {signature.length > 0 && <span className={styles.userSignature}>{signature}</span>}
                      </div>
                      {manageMemberLoading && member.id === userBeingProcessed && <Spinner />}
                      {menuOptions.length > 0 && (
                        <div
                          className={`${parentStyles.options} ${styles.memberActions}`}
                          onKeyUp={(e) => {
                            handleKeyPressed(e)
                          }}>
                          <ReactMenu
                            ariaLabel={t('formlabel.openMoreOptions')}
                            options={menuOptions}
                            menuCSS={styles.optionsMenu}
                          />
                        </div>
                      )}
                    </div>
                  )
                })}
            </div>

            <div className={styles.actionButtonWrapper}>
              <Button style='primary' size='large' text={t('messenger.done')} handleClick={close} />
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  )
}

function isMemberAlreadyInConversation(openedConversation, member) {
  if (openedConversation && openedConversation.active_users) {
    const activeUsers = openedConversation.active_users

    const isExists = activeUsers.some((user) => user.id === member.user_id)
    return isExists
  }
  return false
}

function isMemberAddedForInvitation(members, member) {
  return members.some((m) => m.user_id === member.user_id)
}
export default ManageMembers
